import { Controller } from "@hotwired/stimulus"
import animatedScrollTo from "animated-scroll-to"

export default class extends Controller {
    static targets = [
        'tab',
        'button',
    ]

    static values = {
        index: {
            type: Number,
            default: 0,
        }
    }

    scrollStart() {
      animatedScrollTo(this.element)
    }

    choice({ params: { index } }) {
        this.indexValue = index
        this.scrollStart()
    }

    indexValueChanged(current, old) {
        this.buttonTargets.forEach((element, index) => {
            element.classList.toggle('active', index === current)
        })
        this.tabTargets.forEach((element, index) => {
            element.classList.toggle('active', index === current)
        })
    }
}
